import React, { MouseEvent, useRef, useState } from "react";
import { BiMessageAltError } from "react-icons/bi";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import { Helmet } from "react-helmet";
import { login } from "../../../redux/actions/AuthActions";
import { RootState } from "../../../redux/reducers/AllReducers";

const Login = () => {
    const currUser = useSelector((state: RootState) => state.auth);

    const username = useRef<HTMLInputElement>(null);
    const password = useRef<HTMLInputElement>(null);

    const [error, setError] = useState("");

    const dispatch = useDispatch();
    const handleLogin = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();

        if (
            username.current?.value.trim() !== "" &&
            password.current?.value.trim() !== ""
        ) {
            dispatch(
                login(
                    username.current?.value || "",
                    password.current?.value || ""
                )
            );
        } else {
            setError("Please Fill all the inputs!");
        }
    };

    const isAuth = (): boolean => {
        if (currUser.access && currUser.access !== "") {
            return true;
        }
        return false;
    };

    if (!isAuth()) {
        return (
            <>
                <Helmet>
                    <title>TodoApp | Login</title>
                </Helmet>
                <div className="min-h-screen p-1 sm:pt-20 bg-gradient-to-br from-gray-50 via-gray-200 to-gray-300">
                    <form
                        // style={{ minHeight: "500px" }}
                        className="box-border flex flex-col justify-between max-w-lg mx-auto bg-white border-2 border-gray-400 rounded-md shadow-2xl "
                    >
                        <div className="flex justify-center w-full h-16 bg-gray-200 rounded-t shadow-md">
                            <p className="z-0 self-center text-2xl font-bold text-gray-700 opacity-90">
                                Login
                            </p>
                        </div>
                        {error !== "" && (
                            <div className="relative flex w-full px-2 py-3 text-xl text-center text-white transition-all duration-1000 shadow-md h-14 justify-evenly bg-carnationRed">
                                <h1 className="flex flex-row self-center font-semibold">
                                    <BiMessageAltError
                                        className="self-center mr-2"
                                        size="1.5rem"
                                    />
                                    {error}
                                </h1>
                                <button
                                    type="button"
                                    className="absolute self-center font-semibold right-5"
                                    onClick={() => setError("")}
                                >
                                    <IoIosCloseCircleOutline />
                                </button>
                            </div>
                        )}
                        <div className="flex flex-col px-5 py-10">
                            <div className="form-group">
                                <label
                                    className="px-1 font-semibold"
                                    htmlFor="username"
                                >
                                    Username:
                                </label>
                                <input
                                    className="px-2 py-1.5 mt-1 border border-gray-300 rounded"
                                    type="text"
                                    placeholder="Username"
                                    id="username"
                                    ref={username}
                                />
                            </div>

                            <div className="form-group">
                                <label
                                    className="px-1 font-semibold"
                                    htmlFor="password"
                                >
                                    Password:
                                </label>
                                <input
                                    className="px-2 py-1.5 mt-1 border border-gray-300 rounded"
                                    type="password"
                                    placeholder="Password"
                                    id="password"
                                    ref={password}
                                />
                                <Link
                                    className="mt-1 font-semibold text-blue-600 hover:underline"
                                    to="/forgot-password"
                                >
                                    Forgot Password?
                                </Link>
                            </div>

                            <div className="mt-4 form-group">
                                <button
                                    className="self-center w-full max-w-md px-5 py-2 text-xl font-semibold text-center transition-all duration-300 bg-gray-800 border-2 border-gray-500 rounded shadow-md sm:px-10 sm:text-2xl hover:bg-gray-300 hover:text-gray-900 text-gray-50"
                                    type="submit"
                                    onClick={(e) => handleLogin(e)}
                                >
                                    Login
                                </button>
                                <Link to="/register">
                                    <button className="self-center w-full max-w-md px-5 py-2 mt-4 text-xl font-semibold text-center text-gray-900 transition-all duration-300 border-2 border-gray-500 rounded shadow-md sm:px-10 sm:text-2xl bg-gray-50 hover:bg-gray-300">
                                        Register
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </form>
                </div>
            </>
        );
    } else {
        return <Redirect to="/dashboard" />;
    }
};

export default Login;
